import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'

import { Button, Input } from '../../../components/UI'
import ErrorMessageWithExclamation from '../../../components/UI/ErrorMessageWithExclamation'

import {
  selectErrorResetPassword,
  selectLoadingResetPassword,
} from '../../../routing/fetchingfunction/user/user.reducer'
import { resetPassword } from '../../../routing/fetchingfunction/user/user.action'

import { useQuery } from '../../../hooks'

import { ResetPasswordScheme } from '../../../routing/utils/validators'

const ResetPassword = () => {
  const dispatch = useDispatch()
  const query = useQuery()
  const navigate = useNavigate()

  const isLoading = useSelector(selectLoadingResetPassword)
  const error = useSelector(selectErrorResetPassword)

  const methods = useForm({
    defaultValues: {
      new_password1: '',
      new_password2: '',
    },
    resolver: yupResolver(ResetPasswordScheme),
  })

  const {
    formState: { errors },
    handleSubmit,
    register,
  } = methods

  const handleFormSubmit = (data) => {
    dispatch(
      resetPassword({
        ...data,
        uid: query.get('token_type'),
        token: query.get('token'),
      })
    ).then((response) => {
      if (!response.error) {
        navigate('/login')
      }
    })
  }

  useEffect(() => {
    if (!query.get('token_type') || !query.get('token')) {
      navigate('/forgot-password')
    }
  }, [])

  return (
    <div className="bg-[#FEEBDD] rounded-lg text-primary-100 max-w-[800px] w-full px-[148px] py-16 mx-auto my-16 flex flex-col items-center justify-start">
      <h1 className="text-4xl font-semibold">Reset Password</h1>

      {!!error && (
        <div className="mr-auto mt-[20px] text-error-500">
          <p className="font-bold">Following errors occur</p>
          <ErrorMessageWithExclamation text={error} />
        </div>
      )}

      <FormProvider {...methods}>
        <form
          onSubmit={handleSubmit(handleFormSubmit)}
          className={`w-full ${error ? 'mt-[20px]' : 'mt-[32px]'}`}
        >
          <div className="mb-[20px]">
            <label className="text-sm font-medium mb-[6px]" htmlFor="new-password">
              New Password
            </label>

            <Input
              id="new-password"
              wrapperClassName="w-full"
              placeholder="New Password"
              type="password"
              {...register('new_password1')}
            />

            {errors.new_password1 && (
              <ErrorMessageWithExclamation text={errors.new_password1.message} />
            )}
          </div>

          <div>
            <label className="text-sm font-medium mb-[6px]" htmlFor="confirm-new-password">
              Confirm New Password
            </label>

            <Input
              id="confirm-new-password"
              wrapperClassName="w-full"
              placeholder="Confirm New Password"
              type="password"
              {...register('new_password2')}
            />

            {errors.new_password2 && (
              <ErrorMessageWithExclamation text={errors.new_password2.message} />
            )}
          </div>

          <Button
            className="mt-[24px] w-full h-[44px] font-semibold text-base"
            type="submit"
            isLoading={isLoading}
          >
            Submit
          </Button>
        </form>
      </FormProvider>
    </div>
  )
}

export default ResetPassword
